<script setup lang="ts">
import type { CmsElementSidebarFilter } from "@shopware/composables";
import SwProductListingFilters from "../../listing-filters/SwProductListingFilters.vue";
import { useCategoryListing } from "#imports";

defineProps<{
  content: CmsElementSidebarFilter;
}>();

const { getCurrentFilters } = useCategoryListing();

const showFilter = ref(false);

const toggleFilter = () => {
  showFilter.value = !showFilter.value;
};

import { onClickOutside } from "@vueuse/core";
const filterContainerOut = ref(null);
onClickOutside(filterContainerOut, (event) => {
  if (showFilter.value) toggleFilter();
});
</script>
<template>
  <section class="pt-2 md:pt-4">
    <div class="container">
      <ListingFiltersSwCategoryFilter />
      <div class="flex flex-wrap items-center">
        <div
          class="w-full lg:w-[calc(100%-230px)] xl:w-[calc(100%-298px)] hidden md:block"
        ></div>
        <div
          class="w-full lg:w-[230px] xl:w-[298px] pt-4 lg:pt-0 relative"
          ref="filterContainerOut"
        >
          <div
            @click="toggleFilter"
            class="flex items-center justify-center w-full btn-outline font-inter normal-case max-w-full gap-3 hover:bg-white hover:text-black03 cursor-pointer filterbtn"
          >
            {{ $t("general.filter.label") }}
            <span
              v-if="getCurrentFilters && getCurrentFilters.properties.length"
              class="bg-pink text-sm text-white px-2 py-1 rounded-full"
            >
              {{ getCurrentFilters.properties.length }}
            </span>
            <span>
              <img
                src="assets/images/filter-icon.svg"
                class="w-6 def_img"
                alt=""
              />
              <img
                src="assets/images/cross.svg"
                class="w-6 hidden on_img"
                alt=""
              />
            </span>
          </div>
          <div
            v-if="showFilter"
            class="w-[300px] sm:w-[360px] md:w-[420px] absolute z-40 top-full mt-4 -start-2 md:start-auto lg:end-0 bg-white p-4 md:p-8 lg:p-10 filter-wrap"
            style="box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1)"
          >
            <SwProductListingFilters :content="content" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
